import React from 'react'
import { Tab } from 'semantic-ui-react'
import TabExperienceContent from './TabExperienceContent'
import TabSideprojectContent from './TabSideprojectContent'
import TabSkillContent from './TabSkillContent'
import TabWorksContent from './TabWorksContent'
import { connect } from 'react-redux'
import {changeTab} from '../actions/index.js'

const AboutTabPointing = ({tabinit, change_tab, activeIndex, changeUrl, props, panes}) => (
  <div>
    <Tab menu={{ pointing: true }} panes={panes} className="about-tab-pointing" defaultActiveIndex={activeIndex} value={activeIndex} onTabChange={change_tab} />
  </div>
)

const mapStateToProps = (state, props) => {
  return {
    props: props,
    activeIndex: state.tabsIntReducers,
    panes:[
      { menuItem: props.about_tab_pointing.experience , render: () => <Tab.Pane attached={false}><TabExperienceContent {...props}/></Tab.Pane> },
      { menuItem: props.about_tab_pointing.skills , render: () => <Tab.Pane attached={false}><TabSkillContent {...props}/></Tab.Pane> },
      { menuItem: props.about_tab_pointing.sideproject , render: () => <Tab.Pane attached={false}><TabSideprojectContent {...props}/></Tab.Pane> },
      { menuItem: props.about_tab_pointing.works , render: () => <Tab.Pane attached={false}><TabWorksContent {...props}/></Tab.Pane> },
    ]
  }
}

const mapDispatchToProps = (dispatch) =>{
  return {
    change_tab: (e, { activeIndex })=>{
      dispatch(changeTab(activeIndex))
    },
  }
}

const myAppComp = connect(
  mapStateToProps,
  mapDispatchToProps
)(AboutTabPointing)

export default myAppComp


// WEBPACK FOOTER //
// ./src/components/AboutTabPointing.js